import { useState } from "react";
import { Pagination } from "../Pagination";
import { TextIcon } from "components/atoms";

interface IProps {
  exams: any;
  theme: "light" | "dark";
  textIconStyle?: string;
  handleClick: any;
}

export const TextOptionPagination = ({
  exams,
  theme,
  textIconStyle,
  handleClick,
}: IProps) => {
  const [drillPage, setDrillPage] = useState(1);

  return (
    <>
      {[...exams]
        .slice((drillPage - 1) * 5, drillPage * 5)
        .map((value: any, index: number) => {
          const isDrillSmartGrouping = value._isDrillSmartGrouping === true;
          
          return (
            <div className="text-option-btn-wrapper" key={index}>
              <div className="text-option-section">
                <TextIcon
                  label={isDrillSmartGrouping ? value.GroupName : value.Name}
                  badge={isDrillSmartGrouping ? "DrillSmart" : undefined}
                  icon={true}
                  isReverse={true}
                  iconType={
                    isDrillSmartGrouping
                      ? (value.IsLocked === true ? "lock" : "empty-circle")
                      : value.Status === "Lock" || value.IsLocked === true
                        ? "lock"
                        : value.Status === "Not Started"
                          ? "empty-circle"
                          : value.Status === "Completed" ||
                              value.Status === "Complete"
                            ? "select"
                            : "yellow-timer"
                  }
                  isTabStyle={true}
                  styles={textIconStyle}
                  theme={theme}
                  onClick={() => handleClick(value)}
                />
              </div>
            </div>
          );
        })}
      <Pagination
        pages={exams.length}
        currentPage={drillPage}
        setCurrentPage={setDrillPage}
        theme={theme}
      />
    </>
  );
};
